'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _Logger = require('../lib/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LOG = _Logger2.default.getLogger('FrameEventBusContainer');

var FrameEventBus = null;

var FrameEventBusContainer = function () {
  function FrameEventBusContainer() {
    _classCallCheck(this, FrameEventBusContainer);
  }

  _createClass(FrameEventBusContainer, [{
    key: 'get',
    value: function get() {
      return FrameEventBus;
    }
  }, {
    key: 'set',
    value: function set(frameEventBus) {
      FrameEventBus = frameEventBus;

      this.checkIfLoaded(function () {
        return frameEventBus.loaded ? _q2.default.Promise.resolve() : _q2.default.Promise.reject();
      }).catch(function () {
        LOG.warn('FrameEventBus failed to load');
      });
    }
  }, {
    key: 'checkIfLoaded',
    value: function checkIfLoaded(checkerFn) {
      var _this = this;

      var maxRetries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;
      var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5000;

      return function () {
        var retryCount = maxRetries;

        var check = function check() {
          if (retryCount < 1) {
            return _q2.default.Promise.reject();
          } else {
            retryCount--;
            return checkerFn().catch(function () {
              return _this.wait(delay).then(check);
            });
          }
        };

        return check();
      }();
    }
  }, {
    key: 'wait',
    value: function wait(duration) {
      return new _q2.default.Promise(function (resolve) {
        return setTimeout(resolve, duration);
      });
    }
  }]);

  return FrameEventBusContainer;
}();

var instance = new FrameEventBusContainer();

exports.default = instance;
module.exports = exports['default'];